import { render } from "./ReportsMenu.vue?vue&type=template&id=8b0cf362&scoped=true"
import script from "./ReportsMenu.vue?vue&type=script&lang=js"
export * from "./ReportsMenu.vue?vue&type=script&lang=js"

import "./ReportsMenu.vue?vue&type=style&index=0&id=8b0cf362&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0cf362"]])

export default __exports__